import React, { useState, useEffect } from 'react';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import StyledModal from './StyledModal';

export default function ProfileNotesLogsCall({ call, data, userAccessToken, userId, indId }) {
  const [callLogUserDescriptionEditing, setCallLogUserDescriptionEditing] = useState(null);

  const [callLog, setCallLog] = useState(data);

  const [callDescriptionValue, setCallDescriptionValue] = useState(data.userDescription);
  const [callDescriptionValueEdited, setCallDescriptionValueEdited] = useState(null);
  const [callDescriptionValueEditedValue, setCallDescriptionValueEditedValue] = useState(null);
  const [callDescriptionSaving, setCallDescriptionSaving] = useState(false);
  const cndImageUrl = 'https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/';
  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(userAccessToken);

  var userCallLogRepository = new MedicareProAPI.UserCallLogRepository();
  userCallLogRepository.setAccessToken(userAccessToken);

  const [recordingCallModal, setRecordingCallModal] = useState(false);
  const [recordingCallLink, setRecordingCallLink] = useState(null);

  const handleCallLogUserDescriptionEditing = (initialValue) => {
    setCallLogUserDescriptionEditing(true);
    setCallDescriptionValueEditedValue(initialValue);
  };

  const handleCallDescriptionValueEditedValue = (event) => {
    var val = event.target.value;
    setCallDescriptionValueEditedValue(val);
  };

  const handleSaveCallLogDescription = (event) => {
    setCallDescriptionSaving(true);

    var val = event.target.value;
    val == '' ? (val = null) : '';
    setCallDescriptionValue(val);
    setCallDescriptionValueEdited(null);
    var callId = callLog.id;

    var updatedCallLog = { ...callLog };

    updatedCallLog['userDescription'] = callDescriptionValue;

    setCallLog(updatedCallLog);

    var payload = { userDescription: val };

    userCallLogRepository.updateUserIndCallLog(userId, callId, payload).then((response) => {
      setCallLogUserDescriptionEditing(null);
      setCallDescriptionSaving(false);
    });
  };

  const loadCallRecording = (callData) => {
    setRecordingCallModal(true);

    if (
      callData.getVendor() == 'intulse' ||
      (callData.getVendor() == 'simplii' && !callData.getVendorCallID())
    ) {
      callData.getVendor() == 'simplii'
        ? setRecordingCallLink(callData.getData()['recording'])
        : setRecordingCallLink(callData.getData()['recordingUrl']);
    } else {
      webAPI.getUserCallLogRecording(userId, indId, callData.getId()).then((response) => {
        setRecordingCallLink(response.file.url);
      });
    }
  };

  let classList = [
    'float-right',
    'badge',
    'badge-' +
      ((call.getDirection() ? call.getDirection() === 's' : data.direction == 'Outbound')
        ? 'info'
        : 'success'),
  ];

  return (
    <>
      <StyledModal
        size="lg"
        title="Call Recording"
        footerCloseButton={true}
        show={recordingCallModal}
        onClose={(e) => {
          setRecordingCallLink(null);
          setRecordingCallModal(false);
        }}
      >
        {!recordingCallLink && (
          <p class="alert alert-info small">
            Getting your recording link ready <i class="fas fa-spinner fa-spin"></i>
          </p>
        )}
        {recordingCallLink && (
          <p class="alert alert-success small">
            Your recording is ready.{' '}
            <a href={recordingCallLink} target="_blank">
              Click here to view
            </a>
            .
          </p>
        )}
      </StyledModal>
      <div className="col-12 small">
        <div className="border-bottom cp p-2">
          <strong>
            <i className=" far fa-phone text-primary mr-2"></i> {data.startTime}
          </strong>{' '}
          <em>via</em> {data.vendor}
          <span className={classList.join(' ')}>
            {call.getDirection()
              ? call.getDirection() === 's'
                ? 'Outbound'
                : 'Inbound'
              : data.direction}
          </span>
          {data.duration && <div>Duration: {Utilities.convertSeconds(data.duration)}</div>}
          {data.recording && (
            <div>
              Recording:{' '}
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  loadCallRecording(call);
                }}
              >
                Click here
              </a>
            </div>
          )}
          {data.voicemail !== false && (
            <div>
              Voicemail: <a href={data.voicemail}>Click here</a>
            </div>
          )}
          {data.outcome && data.outcome != '' && <div>Outcome: {data.outcome}</div>}
          {data.operator && data.operator != '' && <div>Operator: {data.operator}</div>}
          {data.notes != '' && <div>Notes: {data.notes}</div>}
          {data?.summary?.getSummary?.().length > 0 && (
            <div>
              AI Summary:
              <ul>
                {data.summary.getSummary().map((item) => {
                  return <li>{item}</li>;
                })}
              </ul>
            </div>
          )}
          {!callDescriptionValue && !callLogUserDescriptionEditing && (
            <div>
              <div
                className="badge badge-info mt-2"
                onClick={() => handleCallLogUserDescriptionEditing()}
              >
                <i class="far fa-plus-circle mr-1"></i>Add description
              </div>
            </div>
          )}
          {callDescriptionValue !== null &&
            !callLogUserDescriptionEditing &&
            !callDescriptionSaving && (
              <div className="rounded mt-2 table-info text-dark p-2">
                {callDescriptionValue}{' '}
                <i
                  class="far fa-pencil ml-2"
                  onClick={() => handleCallLogUserDescriptionEditing(callDescriptionValue)}
                ></i>
              </div>
            )}
          {callLogUserDescriptionEditing && !callDescriptionSaving && (
            <div className="rounded mt-2 table-info text-dark p-1">
              <input
                type="text"
                value={callDescriptionValueEditedValue}
                class="form-control form-control-sm p-1"
                onChange={handleCallDescriptionValueEditedValue}
                onBlur={handleSaveCallLogDescription}
              ></input>
            </div>
          )}
          {callDescriptionSaving && (
            <div className="rounded mt-2 table-info text-dark p-1">
              <i class="fal fa-spinner fa-spin"></i> saving...
            </div>
          )}
        </div>
      </div>
    </>
  );
}
